import PropTypes from 'prop-types'

const InlineHeading = ({ text, level = 2 }) => {
  const getHeadingStyles = (level) => {
    const baseStyles = 'block w-full font-semibold text-white mt-4 mb-2 first:mt-0'

    const levelStyles = {
      1: 'text-2xl font-bold mt-6 mb-3',
      2: 'text-xl font-bold mt-5 mb-3',
      3: 'text-lg font-semibold mt-4 mb-2',
      4: 'text-base font-semibold mt-4 mb-2',
      5: 'text-sm font-medium mt-3 mb-2',
      6: 'text-xs font-medium mt-3 mb-1',
    }

    return `${baseStyles} ${levelStyles[level] || levelStyles[2]}`
  }

  const HeadingTag = `h${level}`

  return <HeadingTag className={getHeadingStyles(level)}>{text}</HeadingTag>
}

InlineHeading.propTypes = {
  text: PropTypes.string.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
}

export default InlineHeading
